import { CharacterTypeEnum } from '@danda/shared';
import type { HealthState } from '@danda/shared';

/**
 * #248: a dead monster/animal is a corpse, not an active scene character, so it
 * is hidden from the Scene Characters panel. There is no loot system (and thus
 * no "items panel" copy of the corpse); it is simply no longer a combatant.
 *
 * A dead NPC is NOT hidden: a named NPC's death is narratively relevant, not
 * loot clutter. PCs are never in this (non-party) panel.
 */
export function isHiddenSceneCorpse(
  healthState: HealthState,
  type: 'pc' | 'npc' | 'monster' | 'animal' | undefined
): boolean {
  return (
    healthState === 'dead' &&
    (type === CharacterTypeEnum.MONSTER || type === CharacterTypeEnum.ANIMAL)
  );
}
